"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOptions = void 0;
var constant_1 = require("../../../../constant");
var constants_1 = require("./constants");
var lodash_1 = require("lodash");
var ChartColors_1 = require("../ChartColors");
var utils_1 = require("../utils");
var barStyles = {
    vertical: function () { return ({ borderRadius: 0 }); },
    horizontal: function (isFirst, isLast, borderRadius) { return ({
        borderRadiusTopLeft: isLast ? borderRadius : 0,
        borderRadiusTopRight: isLast ? borderRadius : 0,
    }); },
};
var mapSeries = function (series) {
    return series.map(function (s) {
        var _a;
        return (__assign(__assign({}, s), { data: (_a = s === null || s === void 0 ? void 0 : s.data) === null || _a === void 0 ? void 0 : _a.map(function (d) { return (d === 0 ? null : d); }) }));
    });
};
var transformSeries = function (categories, originalSeries, direction, visualizationType, colorRamp, borderRadius) {
    if (direction === void 0) { direction = 'horizontal'; }
    if (visualizationType === void 0) { visualizationType = ''; }
    var series = mapSeries(lodash_1.cloneDeep(originalSeries));
    var isCategorical = visualizationType === 'categorical';
    var isSequential = visualizationType === 'sequential';
    if (isCategorical) {
        var cats = series.map(function (s, idx) {
            var styles = barStyles[direction]
                ? barStyles[direction](idx === 0, idx === series.length - 1, borderRadius)
                : {};
            return __assign(__assign(__assign({}, s), { color: s.color || lodash_1.nth(ChartColors_1.categoricalColorsArray, idx) }), styles);
        });
        return cats;
    }
    if (isSequential) {
        var numberOfBars = lodash_1.size(categories);
        var flatDataValues = lodash_1.flatten(lodash_1.map(series, 'data'));
        var minValue_1 = lodash_1.min(flatDataValues) + 1;
        var maxValue = lodash_1.max(flatDataValues) + 1;
        var colors_1 = Object.values(lodash_1.get(ChartColors_1.SequentialChartColor, colorRamp, []));
        var zonesCount = Math.min(numberOfBars, lodash_1.size(colors_1));
        var colorIndexes_1 = constants_1.getColorRampIndexes(zonesCount);
        var diff = maxValue - minValue_1;
        var commonDiff_1 = diff / (numberOfBars - 1);
        var zones_1 = Array.from({ length: zonesCount }).map(function (v, index) {
            var colorIndex = colorIndexes_1.shift();
            var color = lodash_1.get(colors_1, colorIndex);
            return { value: minValue_1 + index * commonDiff_1, color: color };
        });
        return series.map(function (s) { return (__assign(__assign({}, s), { zones: s.zones || zones_1 })); });
    }
    return series;
};
var getSequentialSeriesPlotOptions = function (borderRadius) {
    if (borderRadius === void 0) { borderRadius = 0; }
    return ({
        horizontal: {
            borderRadiusTopRight: borderRadius,
            borderRadiusTopLeft: borderRadius,
        },
        vertical: {
            borderRadiusTopRight: borderRadius,
            borderRadiusTopLeft: borderRadius,
        },
    });
};
var buildOptions = function (_a) {
    var direction = _a.direction, stacking = _a.stacking, onClick = _a.onClick, categories = _a.categories, series = _a.series, theme = _a.theme, visualizationType = _a.visualizationType, _b = _a.colorRamp, colorRamp = _b === void 0 ? 'Blue' : _b, tooltipFormatter = _a.tooltipFormatter, borderRadius = _a.borderRadius, sharedTooltip = _a.sharedTooltip, customTooltipRowValueFn = _a.customTooltipRowValueFn;
    var transformedSeries = transformSeries(categories || [], series, direction || 'vertical', visualizationType, colorRamp, borderRadius);
    var options = {
        chart: {
            type: direction === 'vertical' ? 'column' : 'bar',
        },
        plotOptions: {
            column: {
                stacking: stacking,
            },
            series: __assign(__assign({}, lodash_1.get(getSequentialSeriesPlotOptions(borderRadius), direction, {})), { 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                events: {
                    click: onClick,
                }, minPointLength: 3 }),
        },
        xAxis: { type: 'category', categories: categories },
        series: transformedSeries,
        tooltip: {
            useHTML: true,
            formatter: tooltipFormatter
                ? tooltipFormatter
                : sharedTooltip
                    ? function () {
                        return utils_1.SharedChartTooltipFormatterFn(this.x, utils_1.getTooltipRow.call(this), '', customTooltipRowValueFn ? customTooltipRowValueFn.bind(this) : undefined);
                    }
                    : function () {
                        return utils_1.ChartTooltipFormatterFn(this.color, this.series.name + " (" + this.key + ")", this.y, null, customTooltipRowValueFn ? customTooltipRowValueFn.bind(this) : undefined);
                    },
        },
    };
    if (theme.name === constant_1.DESIGN_SYSTEM) {
        options.colors = constants_1.BAR_CHART_COLORS;
    }
    return options;
};
exports.buildOptions = buildOptions;
